import React from "react";
import { SvgIcon } from "@mui/material";
import { routeManifest } from "../../../access/routeManifest";
import { resolveAccessContext } from "../../../access/capabilities";

const buildSidebarIcon = (IconComponent) =>
  IconComponent ? (
    <SvgIcon fontSize="small">
      <IconComponent />
    </SvgIcon>
  ) : null;

export const getSideBarItems = (access = {}) => {
  const { capabilities: resolvedCapabilities } = resolveAccessContext(access);

  return routeManifest
    .filter(
      ({ capability, path, sidebarLabel }) =>
        sidebarLabel && resolvedCapabilities[capability]
    )
    .map(({ capability, path, sidebarIcon, sidebarLabel }) => ({
      capability,
      title: sidebarLabel,
      path,
      icon: buildSidebarIcon(sidebarIcon),
    }));
};
